import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { ImageUploadModule } from 'angular2-image-upload';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from '../shared/network/interceptors/auth.interceptor';
import { MainInterceptor } from '../shared/network/interceptors/main.interceptor';
import { ErrorHandlerInterceptor } from '../shared/network/interceptors/error-handler.interceptor';
import { SharedModule } from '../shared/shared.module';
import { AccommodationRoutingModule } from './accommodation-routing.module';
import { ListComponent } from './components/list/list.component';
import { CreateComponent } from './components/create/create.component';
import { AddRoomTypeComponent } from './components/create/add-room-type/add-room-type.component';

import { TagInputModule } from 'ngx-chips';
import { AssignLifeExperienceComponent } from './components/assign-life-experience/assign-life-experience.component';
import { ViewAccommodationComponent } from './components/modals/view-accommodation/view-accommodation.component'; // this is needed!

@NgModule({
  declarations: [
    ListComponent,
    CreateComponent,
    AddRoomTypeComponent,
    AssignLifeExperienceComponent,
    ViewAccommodationComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    SharedModule,
    AccommodationRoutingModule,
    ImageUploadModule.forRoot(),
    TagInputModule,
    NgbModalModule
  ],
  exports: [
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MainInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorHandlerInterceptor,
      multi: true
    },
  ]

})
export class AccommodationModule { }
